import { scrollToSection } from "@/lib/scroll";
import { useLang } from "@/constants/i18n";

export const Navbar = () => {
    const { t, lang, setLang } = useLang();

    const go = (e, hash) => {
        e.preventDefault();
        scrollToSection(hash);
    };

    return (
        <header
            data-testid="navbar"
            className="fixed top-0 left-0 right-0 z-50 border-b border-gold/20 bg-ivory/80 backdrop-blur-xl"
        >
            <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 md:px-10">
                <a
                    href="#inicio"
                    data-testid="nav-logo-link"
                    onClick={(e) => go(e, "#inicio")}
                    className="flex items-center gap-3"
                >
                    <span className="flex h-10 w-10 items-center justify-center rounded-t-full border border-gold/60 bg-burgundy font-serif text-lg text-ivory">
                        FP
                    </span>
                    <span className="hidden sm:block">
                        <span className="block font-serif text-lg leading-none tracking-wide text-ink">
                            FP Legacy Insurance
                        </span>
                        <span className="block text-[10px] uppercase tracking-[0.3em] text-burgundy/70">
                            {t.nav.brandSub}
                        </span>
                    </span>
                </a>

                <nav className="hidden items-center gap-8 lg:flex" data-testid="nav-links">
                    {t.nav.links.map((link) => (
                        <a
                            key={link.id}
                            href={link.hash}
                            data-testid={link.id}
                            onClick={(e) => go(e, link.hash)}
                            className="text-sm tracking-wide text-ink/70 transition-colors duration-300 hover:text-burgundy"
                        >
                            {link.label}
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <div
                        data-testid="lang-toggle"
                        className="flex items-center rounded-full border border-gold/40 p-0.5"
                    >
                        {["es", "en"].map((l) => (
                            <button
                                key={l}
                                data-testid={`lang-toggle-${l}`}
                                onClick={() => setLang(l)}
                                className={`rounded-full px-2.5 py-1 text-[11px] uppercase tracking-widest transition-colors duration-300 ${
                                    lang === l
                                        ? "bg-burgundy text-ivory"
                                        : "text-ink/60 hover:text-burgundy"
                                }`}
                            >
                                {l}
                            </button>
                        ))}
                    </div>
                    <button
                        data-testid="nav-cta-button"
                        onClick={(e) => go(e, "#contacto")}
                        className="rounded-full bg-burgundy px-5 py-2.5 text-sm tracking-wide text-ivory transition-[background-color,transform] duration-300 hover:bg-forest active:scale-[0.98]"
                    >
                        {t.nav.cta}
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Navbar;
